// ============================================
// УТИЛИТЫ ДЛЯ РАБОТЫ С COOKIES
// ============================================

// Константы для работы с cookies
const COOKIE_NAME = "cambridge_region";
const COOKIE_DAYS = 30;

// Функция установки cookie
function setCookie(n, v, d) {
  
  // Пробуем сохранить в localStorage как fallback
  try {
    localStorage.setItem(n, v);
  } catch (e) {
    console.warn('setCookie: не удалось сохранить в localStorage:', e);
  }
  
  // Пробуем сохранить в куки
  try {
    const date = new Date();
    date.setTime(date.getTime() + d * 24 * 60 * 60 * 1000);
    const encodedValue = encodeURIComponent(v);
    // Добавляем SameSite=Lax для современных браузеров
    const cookieString = `${n}=${encodedValue};expires=${date.toUTCString()};path=/;SameSite=Lax`;
    document.cookie = cookieString;
    
    // Проверяем, сохранилась ли куки
    setTimeout(() => {
      const allCookies = document.cookie;
      if (!allCookies.includes(n + '=')) {
        console.warn('setCookie: ВНИМАНИЕ! Куки не сохранилась в document.cookie. Используем localStorage.');
      }
    }, 50);
  } catch (e) {
    console.error('setCookie: ошибка при установке куки:', e);
  }
}

// Функция получения cookie
function getCookie(n) {
  // Проверяем все куки для отладки

  
  // Сначала пробуем получить из куки
  let value = null;
  if (document.cookie) {
    // Используем более надежное регулярное выражение
    // Ищем куки, которые могут быть в начале строки, после пробела или точки с запятой
    const escapedName = n.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    const regex = new RegExp("(^|;\\s*)" + escapedName + "=([^;]*)");
    const m = document.cookie.match(regex);
    
    if (m && m[2]) {
      value = decodeURIComponent(m[2].trim());
      return value;
    }
  }
  
  // Если не найдено в куки, пробуем получить из localStorage
  try {
    const localStorageValue = localStorage.getItem(n);
    if (localStorageValue) {
      return localStorageValue;
    }
  } catch (e) {
  }
  
  return null;
}

// Экспортируем функции и константы глобально
window.getCookie = getCookie;
window.setCookie = setCookie;
window.COOKIE_NAME = COOKIE_NAME;
window.COOKIE_DAYS = COOKIE_DAYS;

